import { graphql } from "gql";

const ADMIN_EDIT_TAG_MUTATION = graphql(`
  mutation AdminEditTag($id: ID!, $input: AdminEditTagInput!) {
    adminEditTag(id: $id, input: $input) {
      ...Tag
    }
  }
`);

export default ADMIN_EDIT_TAG_MUTATION;
